module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei8.svg";